import curry from "ramda/es/curry";


/* eslint-disable import/prefer-default-export */
export const selectAllEntities = (state, entity) => {
  const mapped = state.firebase[entity].allIds.map(
    entityId => state.firebase[entity].byId[entityId]
  );
  return mapped;
};

export const firebaseNormalizer = (state, entity) => {
  const entityById = (state.firebase && state.firebase[entity].byId) || {};

  const entityAllIds =
    (state.firebase &&
      state.firebase[entity].allIds &&
      state.firebase[entity].allIds) ||
    [];

  const entityArrayMapped = entityAllIds.map(id => ({
    ...entityById[id]
  }));

  return entityArrayMapped;
};


export const helperMapFunction = curry((param, stuff) => param.stuff === stuff)


export const helperFilterFunction = curry((param, stuff) => param.stuff === stuff)




